import { Accordion } from '@trussworks/react-uswds';
import NAB_BALTIMORE from './DistrictContent/NAD/NAD.NAB_Baltimore';
import NAP_PHILADELPHIA from './DistrictContent/NAD/NAD.NAP_Philadelphia';

const USACEDistrictAccordion = [
  {
    id: '1',
    headingLevel: 'h3',
    title: 'Baltimore District (NAB)',
    content: <NAB_BALTIMORE />,
  },
  {
    id: '2',
    headingLevel: 'h3',
    title: 'Philadelphia District (NAP)',
    content: <NAP_PHILADELPHIA />,
  },
];

const NAD = () => (
  <>
    <section id='nad'>
      <h6 className='margin-bottom-1'>Regulatory Districts with JPA's</h6>
      <Accordion bordered items={USACEDistrictAccordion} multiselectable={true} />
    </section>
  </>
);

export default NAD;
